import type SuperJSON from "superjson";
import { LoanAgreement } from "./LoanAgreement";

export function registerLoanAgreementTransformer(
  superjson: typeof SuperJSON
): void {
  // biome-ignore lint/suspicious/noExplicitAny: SuperJSON's JSONValue constraint doesn't accept TypeScript interfaces
  superjson.registerCustom<LoanAgreement, any>(
    {
      isApplicable: LoanAgreement.isLoanAgreement,
      serialize: (la) => la.serialise(),
      deserialize: (data) => LoanAgreement.deserialise(data),
    },
    "LoanAgreement"
  );
}
